import { AbstractControl, ValidatorFn } from '@angular/forms';
import { storedLength } from '../../utils/text-length';

/**
 * Like `Validators.maxLength`, but measures the value the way the API will receive it - line breaks
 * normalised to CRLF. See `storedLength` for why the two differ.
 *
 * Emits the same error shape as the built-in validator, so existing `hasError('maxlength')`
 * template messages keep working.
 */
export function storedMaxLengthValidator(maxLength: number): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const actualLength = storedLength(control.value);
    return actualLength > maxLength
      ? { maxlength: { requiredLength: maxLength, actualLength } }
      : null;
  };
}
